export default __webpack_public_path__ + "static/rounded_logo_bluetxt_new-85fd6b4b85d46738a9be2cea8e96f699.png";